import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
import { typeScale } from "@/lib/typeScale";

// O `tailwind-merge` só conhece a escala de fonte padrão do Tailwind. Sem
// registrar a dos aplicativos, ele lia `text-small` como cor e, no desempate,
// descartava a outra classe `text-*` da chamada: a cor do texto do botão
// (`text-primary-foreground`) ou o tamanho da descrição do cartão.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: Object.keys(typeScale) }],
    },
  },
});

/** Junta classes e desempata as conflitantes do Tailwind. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
